import PTs from 'prop-types';

import ProfilePhotoTypes from './ProfilePhotoTypes';

const ProfilePhotoTypeCodeShape = PTs.oneOf(ProfilePhotoTypes.codes);

export default ProfilePhotoTypeCodeShape;
